import React, { Fragment } from 'react';
// import

const CollectionItem = ({ collection }) => {
  const { heading, para } = collection;
  return (
    <Fragment>
      <div>
        <div className='img-reactangular'></div>
        <h2 className='text-light mt-2'>{heading}</h2>
        <p className='text-light ml-1'>{para}</p>
      </div>
    </Fragment>
  );
};

export default CollectionItem;
